/**
 * Tiny analytics helper.
 *
 * - If Google Analytics (gtag.js) is installed in public/index.html, every
 *   call below is automatically forwarded to GA4 as an event. Nothing else
 *   to configure.
 * - If GA isn't installed, trackEvent() silently does nothing (so the site
 *   never breaks), but logVisitLocally() still keeps a rolling, on-device
 *   visit log in localStorage that the founders can eyeball from the
 *   browser console during early testing. See README.md -> "Analytics".
 */

export function trackEvent(name, params = {}) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
}

export function trackPageView(pageTitle) {
  trackEvent('page_view', { page_title: pageTitle });
  logVisitLocally(pageTitle);
}

// Simple local fallback so the founders see *something* even before GA is wired up.
export function logVisitLocally(label = 'visit') {
  try {
    const key = 'inivayal_local_visits';
    const existing = JSON.parse(localStorage.getItem(key) || '[]');
    existing.push({ label, at: new Date().toISOString() });
    // keep only the most recent 200 entries
    localStorage.setItem(key, JSON.stringify(existing.slice(-200)));
  } catch (e) {
    // localStorage may be unavailable (private browsing) — fail silently
  }
}

export function getLocalVisits() {
  try {
    return JSON.parse(localStorage.getItem('inivayal_local_visits') || '[]');
  } catch (e) {
    return [];
  }
}
